(() => {
  'use strict';

  const SECTION_TYPE = 'data-section-type';
  const BUTTON_SELECTOR = '[data-share-button]';
  const MESSAGE_SELECTOR = '[data-share-message]';
  const VISIBLE_CLASS = 'is-visible';
  const CONFIRMATION_DURATION = 2200;

  if (customElements.get('share-button')) return;

  customElements.define(
    'share-button',
    class extends HTMLElement {
      constructor() {
        super();
        this.container = this.closest(`[${SECTION_TYPE}]`);
        this.shareButton = this.querySelector(BUTTON_SELECTOR);
        this.shareMessage = this.querySelector(MESSAGE_SELECTOR);
        this.urlToShare = this.shareButton?.dataset.shareUrl || document.location.href;
        this.messageTimer = null;

        if (!this.shareButton) return;

        this.shareButton.addEventListener('click', () => this.handleShare());
        this.updateShareLink();
      }

      async handleShare() {
        if (navigator.share) {
          try {
            await navigator.share({ url: this.urlToShare, title: document.title });
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }

        try {
          await this.copyToClipboard();
          this.showConfirmation();
        } catch (_error) {
          window.prompt('Kopier lenken:', this.urlToShare);
        }
      }

      async copyToClipboard() {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(this.urlToShare);
          return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = this.urlToShare;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();

        if (!copied) throw new Error('Copy failed');
      }

      showConfirmation() {
        if (!this.shareMessage) return;

        window.clearTimeout(this.messageTimer);
        this.shareButton.dataset.shareState = 'copied';
        this.shareMessage.classList.add(VISIBLE_CLASS);
        this.messageTimer = window.setTimeout(() => {
          this.shareMessage.classList.remove(VISIBLE_CLASS);
          delete this.shareButton.dataset.shareState;
        }, CONFIRMATION_DURATION);
      }

      updateShareLink() {
        if (this.container?.getAttribute(SECTION_TYPE) !== 'product') return;

        this.container.addEventListener('theme:variant:change', (event) => {
          if (!event.detail.variant) return;
          this.urlToShare = `${this.urlToShare.split('?')[0]}?variant=${event.detail.variant.id}`;
        });
      }
    }
  );
})();
